import axios from 'axios'
import type { Document, Todo, ApiResponse } from '../types'

const api = axios.create({
  baseURL: '/api',
  headers: {
    'Content-Type': 'application/json',
  },
})

// Documents API
export const documentsApi = {
  getAll: (params?: { type?: string; status?: string }) =>
    api.get<ApiResponse<Document[]>>('/documents', { params }),
  
  getBySlug: (slug: string) =>
    api.get<ApiResponse<Document>>(`/documents/${slug}`),
  
  update: (slug: string, data: { content: string; status?: 'draft' | 'review' | 'final' }) =>
    api.put<ApiResponse<Document>>(`/documents/${slug}`, data),
  
  save: (slug: string, content: string) =>
    api.post(`/documents/${slug}/save`, { content }),
}

// Todos API
export const todosApi = {
  getAll: () =>
    api.get<ApiResponse<{ todos: Todo[]; completed: Todo[] }>>('/todos'),
  
  create: (data: { title: string; description?: string; phase?: string; priority?: 'high' | 'medium' | 'low' }) =>
    api.post<ApiResponse<Todo>>('/todos', data),
  
  update: (id: string, data: { completed?: boolean; title?: string; priority?: 'high' | 'medium' | 'low' }) =>
    api.patch<ApiResponse<Todo>>(`/todos/${id}`, data),
  
  delete: (id: string) =>
    api.delete(`/todos/${id}`),
}

export default api